<template>   

<div>
    <transition name='background'>
        <img :src='background' class='bg'>
    </transition>

    <v-footer v-if="auth.authenticated" absolute="" padless inset color="transparent">
      <v-layout justify-end="">
        <span v-if="footer_color == 'light'" class="white--text subtitle-1">{{user.name}} | {{user.organisation.name}}</span>
        <span v-if="footer_color == 'dark'" class="subtitle-1">{{user.name}} | {{user.organisation.name}}</span>
      </v-layout>
    </v-footer>

</div>

</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      footer_color: process.env.VUE_APP_COLOR_FOOTER
    };
  },
  computed: {
    ...mapState(["app", "user", "auth"]),
    background() {
      return require("../../../public/img/background/" +
        process.env.VUE_APP_BACKGROUND);
    }
  }
};
</script>


<style scoped>
.background-enter-active,
.background-leave-active {
  transition: all 0.5s ease;
}

.background-enter,
.background-leave-to {
  opacity: 0;
}

img.bg {
  /* Set rules to fill background */
  min-height: 100%;
  min-width: 1024px;

  /* Set up proportionate scaling */
  width: 100%;
  height: auto;

  /* Set up positioning */
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: -1;
}

.wrapper {
  /* height: 100vh; */
  /* display: flex; */
}

.video-wrap {
  /* Set up positioning */
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100vh;
}

.video-wrap.video {
  /* Set rules to fill background */
  /* height: 100vh; */

  /* Set up proportionate scaling */
  min-width: 100%;
  min-height: 100%;
  /* height: auto; */
}

.overlay {
  height: 100%;
  width: 100%;

  background: #003657;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 0.7;
}

.front {
  position: relative;
}

@media screen and (max-width: 1024px) {
  /* Specific to this particular image */
  img.bg {
    left: 50%;
    margin-left: -512px; /* 50% */
  }
}
</style>
